export const CONFIGURATION_ROOT_NAMES = ['Contrato', 'Feriados'];
export const CONFIGURATION_WELCOME_ROUTE = '/configuracoes';
export const CONFIGURATION_ROUTE_PREFIXES = [
  CONFIGURATION_WELCOME_ROUTE,
  '/contrato-notificacao',
  '/feriados',
  '/create-feriado',
  '/edit-feriado',
];
